import React, {Component} from "react";
import UserBetHistory from "./UserBetHistory";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import IsAuth from "../../components/IsAuth";
import UserPayments from "./UserPayments";
import UserTakemoney from "./UserTakemoney";
import UserPay from "./UserPay";
import UserPassword from "./UserPassword";
import UserData from "./UserData";
import UserPassport from "./UserPassport";

class UserContainer extends Component {
	render() {
		if (this.props.location.pathname === '/user/') {
			return <Redirect to={'/user/history'} />
		}

		return (
			<div className='body__container__side-right cl-back'>
				<IsAuth />
				<Switch>
					<Route path={'/user/history'} component={UserBetHistory}/>
					<Route path={'/user/payments'} component={UserPayments}/>
					<Route path={'/user/take-money'} component={UserTakemoney}/>
					<Route path={'/user/pay'} component={UserPay}/>
					<Route path={'/user/password'} component={UserPassword}/>
					<Route path={'/user/data'} component={UserData}/>
					<Route path={'/user/passport'} component={UserPassport}/>
				</Switch>
			</div>
		);
	}
}

export default withRouter(UserContainer);



// WEBPACK FOOTER //
// ./src/app/pages/User/UserContainer.js